import React, { Fragment } from 'react';
import { Card as CardReactStrap, CardBody as CardBodyReactStrap } from 'reactstrap';
import PropTypes from 'prop-types';
import { cn } from 'library/utils';

const propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  children: PropTypes.node,
  styleCardBody: PropTypes.object,
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  styleContainer: PropTypes.object,
};

const Card = ({
  title,
  subTitle,
  className,
  children,
  styleCardBody,
  classNameContainer,
  styleContainer,
  classNameTitle,
}) => {
  //! State

  //! Function

  //! Render
  return (
    <CardReactStrap style={styleContainer} className={classNameContainer}>
      <CardBodyReactStrap className={cn('tw-rounded-md', className)} style={styleCardBody}>
        {title && (
          <div className={cn('mb-4 new-design-card-title tw-gap-2', classNameTitle)}>
            <h4>{title}</h4>

            {subTitle && <Fragment>{subTitle}</Fragment>}
          </div>
        )}
        {children}
      </CardBodyReactStrap>
    </CardReactStrap>
  );
};

Card.propTypes = propTypes;
export default React.memo(Card);
